import React from 'react';
import NumberFlow from '@number-flow/react'
import UserPicture from '../components/UserPicture';

export function PeopleListItem({name = 'Firstname Lastname', pictureSrc = null, initials = null, colour = null, balance = 0}){

    const formattedBalance = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(balance);

    let balancePhrase = 'Settled';
    if(balance > 0){
        balancePhrase = `Owes you ` + formattedBalance;
    }else if(balance < 0){
        balancePhrase = `You owe ` + formattedBalance;
    }


    return (
        <div className='flex justify-center items-center gap-4 relative w-full bg-slate-50 dark:bg-slate-900 rounded-xl ring-1 ring-black/10 dark:ring-white/10 ring-inset px-4 py-3'>
            <div className='h-9 w-9 shrink-0'>
                <UserPicture pictureSrc={pictureSrc} initials={initials} colour={colour} />
            </div>
            <div className='flex flex-col w-full'>
                <span className='text-base font-medium text-slate-950 dark:text-white'>{name}</span>
                <span className={`text-xs font-bold ${balance > 0 ? 'text-green-500' : balance < 0 ? 'text-red-500' : 'text-slate-500'} dark:${balance > 0 ? 'text-green-400' : balance < 0 ? 'text-red-400' : 'text-slate-400'}`}>{balancePhrase}</span>
            </div>
        </div>
    );
}

export function PeopleList({children}){
    return (
        <div className='flex flex-col relative gap-2'>
            {children}
        </div>
    );
}